<script>
    import {fade, fly} from 'svelte/transition';
    import app from "../stores/app";
</script>

{#if $app.popup_loader}
    <div class="loader-overlay" transition:fade="{{ duration: 200 }}">
        <div class="loader-box" in:fly="{{ y: -50, duration: 200 }}" out:fly="{{ y: 50, duration: 200 }}">
            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="200px" height="200px"
                 viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
                <path fill="none" stroke="#d1ae6e" stroke-width="8" stroke-dasharray="42.76482137044271 42.76482137044271"
                      d="M24.3 30C11.4 30 5 43.3 5 50s6.4 20 19.3 20c19.3 0 32.1-40 51.4-40 C88.6 30 95 43.3 95 50s-6.4 20-19.3 20C56.4 70 43.6 30 24.3 30z"
                      stroke-linecap="round" style="transform:scale(0.8);transform-origin:50px 50px">
                    <animate attributeName="stroke-dashoffset" repeatCount="indefinite" dur="1s" keyTimes="0;1"
                             values="0;256.58892822265625"></animate>
                </path>
            </svg>
        </div>
    </div>
{/if}
<style>
    .loader-overlay {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 9900;
    }

    .loader-box {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        background: #fff;
        border-radius: 50%;
        box-shadow: 0 0 14px -2px rgba(0, 0, 0, 0.70);
        -webkit-box-shadow: 0 0 14px -2px rgba(0, 0, 0, 0.70);
        -moz-box-shadow: 0 0 14px -2px rgba(0, 0, 0, 0.70);
        padding: 10px;
    }

    svg {
        width: 60px;
        height: 60px;
    }
</style>